module.exports = __webpack_public_path__ + "img/mb.986c1fda.png";